import {
  Apple,
  Download as DownloadIcon,
  ExternalLink,
  Globe2,
  Monitor,
  Package,
  Smartphone,
} from 'lucide-react';

const icons = {
  Apple,
  Globe2,
  Monitor,
  Package,
  Smartphone,
};

function PlatformIcon({ name, size = 20 }) {
  const Icon = icons[name] || Package;
  return <Icon size={size} />;
}

export default function Download({ content }) {
  return (
    <section className="section section-download" id="download">
      <div className="section-inner">
        <div className="download-layout">
          <div className="download-copy">
            <p className="eyebrow">{content.eyebrow}</p>
            <h2>{content.title}</h2>
            <p>{content.intro}</p>

            <div className="download-release">
              <span>{content.versionLabel}</span>
              <strong>{content.release}</strong>
              <small>{content.releaseMeta}</small>
            </div>

            <a className="btn-secondary download-notes" href={content.releaseUrl} target="_blank" rel="noopener noreferrer">
              <ExternalLink size={16} />
              <span>{content.releaseNotes}</span>
            </a>
          </div>

          <div className="editor-downloads" aria-label={content.editorLabel}>
            {content.editors.map((item) => (
              <a className="download-card editor-card" key={item.title} href={item.href}>
                <span className="download-card-icon">
                  <PlatformIcon name={item.icon} />
                </span>
                <span className="download-card-body">
                  <strong>{item.title}</strong>
                  <span>{item.detail}</span>
                  <small>{item.note}</small>
                </span>
                <DownloadIcon className="download-card-action" size={18} />
              </a>
            ))}
          </div>
        </div>

        <div className="template-header">
          <div>
            <p className="panel-label">{content.templatesLabel}</p>
            <h3>{content.templatesTitle}</h3>
          </div>
          <p>{content.templatesIntro}</p>
        </div>

        <div className="template-grid" aria-label={content.templatesTitle}>
          {content.templates.map((item) => (
            <a className="download-card template-card" key={item.title} href={item.href}>
              <span className="download-card-icon small">
                <PlatformIcon name={item.icon} size={18} />
              </span>
              <span className="download-card-body">
                <strong>{item.title}</strong>
                <span>{item.detail}</span>
              </span>
              <DownloadIcon className="download-card-action" size={16} />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
